import React from 'react';
import { ToastContainer as ReactToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ToastContainer = () => {
  return (
    <ReactToastContainer
      position="bottom-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop={false}
      closeOnClick
      rtl={false}
      pauseOnFocusLoss
      draggable
      pauseOnHover
      theme="light"
      style={{ width: '350px', backgroundColor: 'transparent', border: 'none' }}
      toastStyle={{ backgroundColor: '#FEF7F7', borderRadius: '10px', border: '1px solid #e0e0e0', color: '#E30000B2' }}
      bodyStyle={{ color: '#E30000B2' }}
      />
  );
};

export default ToastContainer;